import React, { Component } from 'react';

class Home extends Component {
  render() {
    var loggedin = localStorage.getItem("loggedin");
    var user = localStorage.getItem("user");
    if (localStorage.getItem("loggedin") === "0") {

      localStorage.setItem("loggedin", "1");
      setTimeout(
        function(){
        window.location.href = "/"; }, 100
      );
    }

    return (
      <div className="splash-landing">
        <h2 className="welcome animate hidden-default fade-in-up">
          Let's learn {user}!
        </h2>
        <h3 className="font-large animate hidden-default fade-in-up one-s-delay">
          What you would like to learn?
        </h3>
        <div className="languages animate hidden-default fade-in-up">
          <a href="/choose-mode" className="language animate hidden-default fade-in-up">
            <img src="https://cdn0.iconfinder.com/data/icons/195-flat-flag-psd-icons/70/Mexico.png" />
            <h3>Spanish</h3>
          </a>
          <a href="/practice-french" className="language animate hidden-default fade-in-up">
            <img src="https://cdn0.iconfinder.com/data/icons/195-flat-flag-psd-icons/70/France.png" />
            <h3>French</h3>
          </a>
          <div className="language animate hidden-default fade-in-up">
            <img src="https://cdn0.iconfinder.com/data/icons/195-flat-flag-psd-icons/70/Germany.png" />
            <h3>German</h3>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
